import React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TextCurriculum from '../../text/TextCurriculum';
import TableSortLabel from '@mui/material/TableSortLabel';
import { Typography } from '@mui/material';

const TableHeadColumns = ({ id, columns, onRequestSort, order, orderBy, style, showSetting }) => {
  return (
    <TableHead id={`thead-${id}`} className={`sticky z-10 ${showSetting ? 'top-14' : 'top-0px'}`}>
      <TableRow style={style}>
        {columns.map((column) => (
          <TableCell
            key={column.key}
            align={column.align ? column.align : 'left'}
            padding='normal'
            sortDirection={orderBy === column.key ? order : false}
            width={column.width ? column.width : 'auto'}
            className={`uppercase ${column.className ?? ''}`}
            style={column.stickyLeft != null ? { left: column.stickyLeft } : undefined}
          >
            {['log', 'avatar', 'note', 'actions', 'checkIds', 'index'].includes(column.key) ||
            !column.sort ? (
              <Typography component={'span'} variant='inherit'>
                {column.caret && <TextCurriculum label={column.label} />}
                {!column.caret && column.label}
              </Typography>
            ) : (
              <TableSortLabel
                active={orderBy === column.key}
                direction={orderBy === column.key ? order : 'asc'}
                onClick={(e) => onRequestSort(e, column.key)}
              >
                <Typography component={'span'} variant='inherit'>
                  {column.caret && <TextCurriculum label={column.label} />}
                  {!column.caret && column.label}
                </Typography>
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeadColumns;
